'use client';
import {HoneycombWebSDK} from '@honeycombio/opentelemetry-web';
import {getWebAutoInstrumentations} from '@opentelemetry/auto-instrumentations-web';

import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';

const configDefaults = {
  ignoreNetworkEvents: true,
  propagateTraceHeaderCorsUrls: [
    // adds span trace ids to all request on mixpanel domains
    /^https:\/\/(.+\.)?mixpanel\.(com|org)/g,
  ],
};

/**
 * @see https://docs.honeycomb.io/send-data/javascript-browser/honeycomb-distribution/
 */
const sdk = new HoneycombWebSDK({
  /** set debug & localVisualizations to true for local debugging on traces */
  debug: false,
  localVisualizations: false,
  apiKey: HONEYCOMB_TOKEN,
  serviceName: `web-client`,
  instrumentations: [
    getWebAutoInstrumentations({
      // Loads custom configuration for xml-http-request instrumentation.
      '@opentelemetry/instrumentation-xml-http-request': configDefaults,
      '@opentelemetry/instrumentation-fetch': configDefaults,
      '@opentelemetry/instrumentation-document-load': configDefaults,
    }),
  ],
  resourceAttributes: {
    'user.id': userCookieUtils.getUserIdentityFromCookie()?.id,
  },
});
sdk.start();
